<script setup>
import { computed } from "vue";
import { getDefaultRouteForMode } from "@/utils/permissions";

const homeRoute = computed(() => getDefaultRouteForMode());
</script>

<template>
    <router-link :to="homeRoute">
        <v-tooltip bottom>
            <template #activator="{ on, attrs }">
                <v-btn icon class="primary--text" v-on="on" v-bind="attrs">
                    <v-icon>mdi-home</v-icon>
                </v-btn>
            </template>
            <span>Home</span>
        </v-tooltip>
    </router-link>
</template>